import React, { useEffect } from "react";
import { useState } from "react";
import classNames from "classnames";
import TextSide from "../TextSide";
import ImageSide from "../ImageSide";
import TplSide from "../TplSide";
import GraphSide from "../GraphSide";
import pictures from "../../assets/picture.png";
import sucai from "../../assets/sucai.svg";
import template from "../../assets/template.png";
import text from "../../assets/text.png";
import { LeftWrapper } from "./styled";
import pictures_sel from "../../assets/picture-selected.png";
import sucai_sel from "../../assets/sucai-selected.svg";
import template_sel from "../../assets/template-selected.png";
import text_sel from "../../assets/text-selected.png";

export const isTplSide = "TplSide";
export const isTextComponent = 1;
export const isImageComponent = 2;
export const isGraphComponent = 3;

const Left = () => {
  const [showSide, setShowSide] = useState(0);
  const [showSelectedImg, setShowSelectedImg] = useState(false);
  const [showSelectedImg1, setShowSelectedImg1] = useState(false);
  const [showSelectedImg2, setShowSelectedImg2] = useState(false);
  const [showSelectedImg3, setShowSelectedImg3] = useState(false);

  const _setShowSide = (which) => {
    if (showSide === which) {
      setShowSide(0);
    } else {
      setShowSide(which);
    }
  };

  useEffect(() => {
    document.getElementById("center").addEventListener("click", () => {
      setShowSide(0);
    });
  }, []);

  return (
    <LeftWrapper>
      <ul className="cmps">
        <li
          className={classNames(
            "cmp",
            showSide === isTplSide ? "selected" : ""
          )}
          onClick={() => _setShowSide(isTplSide)}
          onMouseOver={() => setShowSelectedImg(true)}
          onMouseLeave={() => setShowSelectedImg(false)}
        >
          <img
            src={
              showSelectedImg || showSide === isTplSide
                ? template_sel
                : template
            }
            alt="template"
            width={26}
            height={26}
          />
          <span>模板</span>
        </li>
        <li
          className={classNames(
            "cmp",
            showSide === isTextComponent ? "selected" : ""
          )}
          onClick={() => _setShowSide(isTextComponent)}
          onMouseOver={() => setShowSelectedImg1(true)}
          onMouseLeave={() => setShowSelectedImg1(false)}
        >
          <img
            src={
              showSelectedImg1 || showSide === isTextComponent ? text_sel : text
            }
            alt="text"
            width={26}
            height={26}
          />
          <span>文本</span>
        </li>
        <li
          className={classNames(
            "cmp",
            showSide === isImageComponent ? "selected" : ""
          )}
          onClick={() => _setShowSide(isImageComponent)}
          onMouseOver={() => setShowSelectedImg2(true)}
          onMouseLeave={() => setShowSelectedImg2(false)}
        >
          <img
            src={
              showSelectedImg2 || showSide === isImageComponent
                ? pictures_sel
                : pictures
            }
            alt="pictures"
            width={26}
            height={26}
          />
          <span>图片</span>
        </li>
        <li
          className={classNames(
            "cmp",
            showSide === isGraphComponent ? "selected" : ""
          )}
          onClick={() => _setShowSide(isGraphComponent)}
          onMouseOver={() => setShowSelectedImg3(true)}
          onMouseLeave={() => setShowSelectedImg3(false)}
        >
          <img
            src={
              showSelectedImg3 || showSide === isGraphComponent
                ? sucai_sel
                : sucai
            }
            alt="sucai"
            width={26}
            height={26}
          />
          <span>素材</span>
        </li>
      </ul>

      {showSide === isTextComponent && <TextSide />}
      {showSide === isImageComponent && <ImageSide />}
      {showSide === isTplSide && <TplSide />}
      {showSide === isGraphComponent && <GraphSide />}
    </LeftWrapper>
  );
};

export default Left;
